<template>
  <v-app data-club-card-info>
    <CoreDialog
      v-model="isDialogVisible"
      data-qa="club_card_info"
      title="Ваша клубная карта"
      :min-height="isMobile ? undefined : '720px'"
      :size="isMobile ? 'fullscreen' : 'lg'"
      divider
    >
      <template #prependBtn="{ btnProps }">
        <v-btn
          v-bind="btnProps"
          @click="handleCloseDialog"
        >
          <span class="ui-icon-close-not-a-circle" />
        </v-btn>
      </template>
      <div class="club-card-info__card-container">
        <div class="club-card-info__card text-body-1 bg-gray-0--text">
          <div class="d-flex align-center text-h6">
            <img
              src="/static/_v1/pd/icons/ui-kit/club/club-percent-white.svg"
              class="mr-2"
              width="24"
              height="24"
              alt="Иконка Процент Клуба"
            >
            Клуб ПроДокторов
          </div>
          <div class="d-flex flex-column align-center">
            <img
              src="/static/_v1/pd/icons/ui-kit/club/club-check-white.svg"
              class="mb-2"
              width="72"
              height="72"
              alt="Иконка Галочка Клуба"
            >
            <span
              class="text-h6 mb-1"
              data-qa="club_card_info_user_phone"
            >
              {{ formattedPhone }}
            </span>
            <span class="text-body-2">
              в клубе до {{ clubData.cardDateEnd }}
            </span>
          </div>
          <div>
            Если возникнут вопросы:
            <br>8 800 707-31-29
          </div>
        </div>
      </div>
      <template #actions>
        <v-btn
          color="primary"
          data-qa="club_card_info_fixed_close_button"
          depressed
          block
          @click="handleCloseDialog"
        >
          Закрыть
        </v-btn>
      </template>
    </CoreDialog>
  </v-app>
</template>

<script>
import { CLUB_EVENTS } from 'www/constants'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import formatPhone from 'src/functions/formatPhone'

export default {
  components: {
    CoreDialog,
  },
  data() {
    return {
      isDialogVisible: false,
      clubData: window.USER.club,
      isMobile: window.MOBILE_VERSION,
      userPhone: window.USER.userPhone,
    }
  },
  computed: {
    formattedPhone() {
      return formatPhone({
        phone: this.userPhone,
        country: {
          iso: window.COUNTRY_DATA.iso,
        },
      })
    },
  },
  created() {
    window.addEventListener(CLUB_EVENTS.cardInfoOpen, ({ detail }) => {
      if (detail) {
        if (detail.clubData) {
          this.clubData = detail.clubData
        }

        if (detail.userPhone) {
          this.userPhone = detail.userPhone
        }
      }

      this.isDialogVisible = true
    })
  },
  methods: {
    handleCloseDialog() {
      this.isDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.club-card-info {
  &__card-container {
    min-width: 250px;
    min-height: 400px;
    max-width: 300px;
    max-height: 480px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }

  &__card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 8px;
    text-align: center;
    border-radius: $border-radius-md;
    background-color: $ui-kit-error;
    background-image: $club-coral-double-radial-gradient;
  }
}
</style>

<style lang="scss">
@import '~www/themes/doctors/common/mixins';

#app[data-club-card-info] {
  @include v-app-reset;
}
</style>
